export const TcUploadStudentDetailsHeader = [
  {
    headerName: 'Sl No.',
    field: 'sl_no',
    width: 130,
  },
  {
    headerName: 'Admission No',
    field: 'admn_no',
    sortable: true,
    width: 180,
  },
  {
    headerName: 'Student Name',
    field: 'student_name',
    sortable: true,
    width: 300,
  },
  {
    headerName: 'Class',
    field: 'class',
    sortable: true,
    width: 130,
  },
  {
    headerName: 'Course',
    field: 'course_name',
    sortable: true,
    width: 300,
  },
  {
    headerName: 'Course Enrollment Date',
    field: 'course_enrollment_date',
    sortable: true,
    width: 250,
  },
  {
    headerName: 'CRO',
    field: 'cro_name',
    sortable: true,
    width: 300,
  },
  {
    headerName: 'Total Sales Amount',
    field: 'total_sales_amount',
    sortable: true,
    width: 250,
  },
  {
    headerName: 'OGA Projected Total Sessions',
    field: 'total_sessions',
    sortable: true,
    width: 300,
  },
  {
    headerName: 'Total Fee Collected',
    field: 'collected_fee',
    sortable: true,
    width: 300,
  },
  {
    headerName: 'Total Sessions Completed',
    field: 'total_sessions_completed',
    sortable: true,
    width: 300,
  },
  {
    headerName: 'Last Session Date',
    field: 'last_session_date',
    width: 230,
  },
  {
    headerName: 'Inactive Reason',
    field: 'course_inactive_reason',
    width: 300,
  },
  {
    headerName: 'Inactive Remarks',
    field: 'course_inactive_remarks',
    width: 300,
  },
  {
    headerName: 'Inactive Marked Time',
    field: 'course_inactive_marked_time',
    width: 300,
  },
  {
    headerName: 'Mode Of Tc Upload',
    field: 'mode_of_tc_ulpoad',
    width: 250,
  },
  {
    headerName: 'Active Status on other Course',
    field: 'active_status_on_other_course',
    width: 250,
  },
  {
    headerName: 'Approval',
    field: 'approval',
    width: 200,
  },
];
